import { ExternalLink } from "@octopusdeploy/design-system-components";
import type { ArtifactResource } from "@octopusdeploy/octopus-server-client";
import type { FC } from "react";
import { repository } from "~/clientInstance";
const ArtifactLink: FC<{
    artifact: ArtifactResource;
}> = (props) => (<ExternalLink href={repository.resolve(props.artifact.Links["Content"])} hideIcon={true} key={props.artifact.Id} trackAnalytics={false} downloadFileName={props.artifact.Filename}>
        {props.artifact.Filename}
    </ExternalLink>);
ArtifactLink.displayName = "ArtifactLink";
export default ArtifactLink;
